import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {AnalyticsService} from '../common/analytics.service';
import {
  AppState,
  ContractType, Dictionary,
  financeStateId,
  MortgageOverview, PaymentOverview,
  PaymentPlan,
  PaymentPlanType
} from '../state/AppState';
import {Store} from '@ngrx/store';
import {AddPayment, addPayment} from '../state/effects.actions';
import {Observable} from "rxjs";
import {map} from "rxjs/operators";


export interface PaymentDialogData {
  mortgageId: string;
  scenarioId: string;
  contractType: ContractType;
}

@Component({
  selector: 'payments-dialog',
  templateUrl: 'payments.component.html'
})
export class PaymentsDialogComponent {
  _payments$: Observable<Dictionary<PaymentOverview>>;

  constructor(
    private dialogRef: MatDialogRef<PaymentsDialogComponent>,
    private store: Store<AppState>,
    @Inject(MAT_DIALOG_DATA) private data: PaymentDialogData,
    private analytics: AnalyticsService
  ) {
    this.analytics.action('openedPaymentDialog');
    this._payments$ = this.store.pipe(
      map(state => state[financeStateId].scenarios[data.scenarioId].mortgages[data.mortgageId].payments)
    );
  }

  get payments() {
    return this._payments$;
  }

  get mortgageId() {
    return this.data.mortgageId;
  }

  get scenarioId() {
    return this.data.scenarioId;
  }

  isPaymentSupported(): boolean {
    return ContractType[this.data.contractType] !== ContractType.SAVING;
  }

  addPaymentStrategy() {
    this.store.dispatch(addPayment({
      scenarioId: this.data.scenarioId,
      mortgageId: this.data.mortgageId,
      plan: {
        amount: 0,
        startAtMonth: 1,
        planType: PaymentPlanType.ONCE
      } as PaymentPlan
    } as AddPayment));
  }


  close(): void {
    this.dialogRef.close();
  }
}
